import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-24 text-center" data-id="element-752" data-mp="w3zsnkrmzrwf">
      <p className="text-sm font-semibold text-muted" data-id="element-753" data-mp="105uucqdhc7aq">404</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-ink" data-id="element-754" data-mp="104be2zrtpw8y">Deze pagina bestaat niet</h1>
      <p className="mt-3 text-sm text-muted" data-id="element-755" data-mp="156itjzbv3ug1">Het product is mogelijk uitverkocht of verplaatst. Kijk eens in ons assortiment.</p>
      <Link to="/shop" className="mt-8 inline-flex h-11 items-center rounded-lg bg-ink px-5 text-sm font-semibold text-white hover:bg-ink-soft" data-id="element-756" data-mp="1a27v287fzlez">
        Bekijk alle producten
      </Link>
    </div>;
}